var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-tooltip',{staticStyle:{"display":"inline"},scopedSlots:_vm._u([{key:"tooltip",fn:function(){return [_vm._v(" Verified! ")]},proxy:true}])},[_c('i',{staticClass:"bx bx-badge-check",staticStyle:{"color":"#6363dd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }